import { MapSettings as View } from 'map-settings'
import { useMapNavStore } from '~map-preview/states/mapNav'

export const MapSettings = () => {
  const { activeMapSettingsTab, setActiveMapSettingsTab } = useMapNavStore()
  return (
    <View
      activeTab={activeMapSettingsTab}
      onTabChange={(value) => setActiveMapSettingsTab(value)}
    />
  )
}
